import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useGenders } from "melco-shared-logic";



type GenderListProps = {
  name?: string;
  onChange?: (value: string) => void;
  value?: string;
  selectedCountry?: string;
  mode?: string;
  readOnly?: boolean
  disabled?: boolean
};

export const GenderSelect: React.FC<GenderListProps> = ({
  value,
  onChange,
  mode,
  disabled
}) => {
  const { t } = useTranslation();
  const { genders } = useGenders();

  const stateList = (genders).map(
    (genders) => ({
      value: genders.code,
      label: genders.name,
    })
  );



  return (

    <Select
      mode={mode === "multiple" ? "multiple" : undefined}
      allowClear
      placeholder={t("users.profiledetails.gender")}
      style={{ width: "100%", minWidth: "150px" }}
      maxTagCount={1}
      options={stateList}
      onChange={onChange}
      value={value}
      disabled={disabled}
    //readonly={disabled}

    />

  );
};
